
import { mapGetters, mapState } from 'vuex';
import { TRANSPARENT_IMAGE_URL } from '@/constants/IMAGE_URLS';
import EmbeddedSocialMediaReview from './EmbeddedSocialMediaReview';
import pinchZoom from '@/mixins/pinchZoom';

export default {
  i18nComponentKey: 'ReviewsShow.components.ReviewMediaSection',
  name: 'ReviewMediaSection',
  components: { EmbeddedSocialMediaReview },
  mixins: [pinchZoom],
  props: {
    review: {
      type: Object,
      required: true
    },
    mediaIndex: { type: Number, default: 0 },
    showExpand: { type: Boolean, default: true }
  },
  data() {
    return { currentIndex: 0 };
  },
  computed: {
    ...mapGetters('review', ['isEmbeddedSocialMediaType']),
    ...mapState('reviewSettings', ['reviewSettings']),
    mediaShape() {
      return this.reviewSettings.show_thumbnail_as_square_on_popup
        ? 'square'
        : 'original-in-square';
    }
  },
  watch: {
    zoomScale(newValue, oldValue) {
      if (newValue > 1 && oldValue <= 1) {
        this.$refs.flicking.disableInput();
      } else if (newValue <= 1 && oldValue > 1) {
        this.$refs.flicking.enableInput();
      }
    }
  },

  created() {
    this.currentIndex = this.mediaIndex;
  },
  methods: {
    willChange(e) {
      this.currentIndex = e.index;
    },
    clickThumbnail(index) {
      this.$refs.flicking.moveTo(index);
    },
    onClickExpand(event) {
      this.$emit('expand', {
        mediaIndex: this.currentIndex + 1,
        event
      });
    },
    videoSrc(mediaPosition) {
      const videoIdx = mediaPosition ? mediaPosition - 1 : 0;
      return this.review.videos[videoIdx]?.url;
    },
    imageSrc(mediaPosition) {
      const imageIdx = mediaPosition
        ? mediaPosition - this.review.videos.length - 1
        : 0;
      return this.review.images[imageIdx]?.url || TRANSPARENT_IMAGE_URL;
    }
  }
};
